import React, {useEffect, useState, useCallback} from 'react';
import {IconoirEditPencil, IconoirList, IconoirViewColumns2} from '@ey-xd/motif-icon';
import {createProjectStepsIndex} from '../../../../util/uiconstants';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {labels} from '../../../../util/utils';
import OutputText from '@ey/canvascoreservices/OutputText';
import StyledTeamsComponents from './StyledTeamsComponents';
import StyledTeams from './StyledTeams';
import StyledToolbar from './StyledToolbar';
import ListView from './ListView';
import Step4OrgChart from '../Step4OrgChart';
import Badge from '../../../CoreWrappers/Badge';
import StyledTabMenu from './TabMenu/StyledTabMenu';
import {Buffer} from 'buffer';

import {MotifButton, MotifButtonGroup} from '@ey-xd/motif-react';
import Button from '../../../CoreWrappers/Button';

const TeamsComponents = (props) => {
	const viewTypes = {
		CARD: labels.cardView,
		LIST: labels.listView
	};
	const [viewType, setViewType] = useState(viewTypes.CARD);
	const fetchedTeams = props.nodes !== null;
	const hasTeams = fetchedTeams && props.nodes.length > 0;
	useEffect(() => {
		setViewType(viewTypes.CARD);
	}, []);

	const renderToolBar = () => {
		return (
			<StyledToolbar>
				<StyledTabMenu className="custom-tab-menu">
					<MotifButtonGroup size="small">
						<MotifButton variant="secondary" size="small" onClick={() => setViewType(viewTypes.CARD)}>
							<MotifIcon fill="none" iconFunction={IconoirViewColumns2} />
							{labels.cardView}
						</MotifButton>
						<MotifButton variant="secondary" size="small" onClick={() => setViewType(viewTypes.LIST)}>
							<MotifIcon size="20" fill="none" iconFunction={IconoirList} />
							{labels.listView}
						</MotifButton>
					</MotifButtonGroup>
				</StyledTabMenu>
			</StyledToolbar>
		);
	};

	const viewProps = {
		components: props.nodes,
		handleEditIconClick: props.handleEditIconClick,
		project: props.project,
		clientEngagements: props.clientEngagements,
		projectOwners: props.projectOwners
	};

	const renderBalkan = () => {
		return (
			<>
				<section className="chart-heading">
					<div class="left-section">
						<OutputText body2>{labels.organizationalChartHeading}</OutputText> <Badge value={props.nodes.length} />
					</div>
					<MotifIcon
						src={IconoirEditPencil}
						title={labels.edit}
						size="20"
						onClick={() => props.handleEditIconClick(createProjectStepsIndex.createOrgChart)}
					/>
				</section>
				<Step4OrgChart nodes={props.nodes} />
			</>
		);
	};

	const renderListView = () => <ListView {...viewProps} />;

	return (
		<StyledTeamsComponents>
			{hasTeams && (
				<>
					{renderToolBar()}
					<StyledTeams>
						{viewType === viewTypes.CARD && renderBalkan()}
						{viewType === viewTypes.LIST && renderListView()}
					</StyledTeams>
				</>
			)}
		</StyledTeamsComponents>
	);
};

export default TeamsComponents;
